import { config } from "./config";
import { common } from "./common";

// const
const base_url = config.api.url;

// api call
export const api = {
  async call(data: any = {}, response: any, final?: any) {
    getData(data);
    // server side rendering
    if (data.ssr) {
      let myPromise = new Promise(function (resolve, reject) {
        fetch(data.url, getOptions(data))
          .then((response) =>
            response.text().then((data) => ({
              status: response.status,
              data: data,
            }))
          )
          .then((result: any) => {
            if (validateData(result)) {
              try {
                result.data = JSON.parse(result.data);
              } catch (e: any) {
                result.data = {
                  error: e.toString(),
                };
              }
              notify(data, result);
              resolve(result);
            }
          })
          .catch((err) => {
            let result = {
              status: 404,
              data: {
                error: err.toString(),
              },
            };
            notify(data, result);
            resolve(result);
          });
      });
      return myPromise;
    } else {
      // client side rendering
      fetch(data.url, getOptions(data))
        .then(async (response) => {
          //refresh token
          if (response.status === 401) {
            let refreshTokenResult: any = await refreshAccessToken();
            if (refreshTokenResult.status === 200) {
              let _data = JSON.parse(refreshTokenResult.data);
              common.localSet("authData", common.crypt(_data?.data, true));
              const newAccessToken = _data?.data?.token;
              const options = getOptions(data);
              options.headers.Authorization = `Bearer ${newAccessToken}`;
              return fetch(data.url, options).then(async (resp) => {
                return resp.text().then((data) => ({
                  status: resp.status,
                  data: data,
                }));
              });
            } else {
              localStorage.clear();
              common.redirect();
            }
          } else {
            return response.text().then((data) => ({
              status: response.status,
              data: data,
            }));
          }
        })
        .then((result: any) => {
          try {
            result.data = JSON.parse(result.data);
          } catch (e: any) {
            result.data = {
              error: e.toString(),
            };
          }
          notify(data, result);
          response(result);
          //}
        })
        .catch((err) => {
          let result = {
            status: 404,
            data: {
              error: err.toString(),
            },
          };
          notify(data, result);
          response(result);
        })
        .finally(() => {
          if (typeof final !== "undefined") {
            final();
          }
        });
    }
  },
};

// support
const getData = (data: any = {}) => {
  data.repeat = data.repeat || false;
  if (!data.repeat) {
    data.auth = data.auth || "token";
    data.type = data.type || "standard";
    data.method = data.method || "POST";
    data.cType = data.cType || 1;
    data.query = data.query || "";
    data.body = data.body || "";
    data.keyQuery = data.keyQuery || "";
    data.notify = data.notify ?? true;
    // set url
    if (data.type == "third") {
      data.url = data.url + data.query;
    } else {
      data.url = base_url + data.url + data.query;
      if (data.keyQuery != "") {
        for (let key in data.keyQuery) {
          data.url = data.url.replace(`:${key}`, data.keyQuery[key]);
        }
      }
    }
    // set body
    if (data.body) {
      if (data.cType == 1) {
        data.body = data.body ? JSON.stringify(data.body) : "";
      } else if (data.cType == 2) {
        let bodyParam = [];
        for (let property in data.body) {
          let encodedKey = encodeURIComponent(property);
          let encodedValue = encodeURIComponent(data.body[property]);
          bodyParam.push(encodedKey + "=" + encodedValue);
        }
        data.body = bodyParam.join("&");
      }
    }
  }
};

function getOptions(data: any) {
  let reqOptions: any = {
    method: data.method,
    headers: getHeaders(data),
  };

  if (data.body) {
    reqOptions.body = data.body;
  }
  return reqOptions;
}

function getHeaders(data: any) {
  // default
  let headers: any = {};

  // content types
  let contentTypes: any = {
    1: "application/json",
    2: "application/x-www-form-urlencoded",
    3: "application/vnd.oracle.adf.action+json",
    4: "application/vnd.oracle.adf.resourceitem+json",
    5: "application/vnd.oracle.adf.batch+json",
    6: "multipart/form-data",
  };
  if (data.cType !== 6) {
    headers["Content-Type"] = contentTypes[data.cType];
  }

  // extra content types
  let moreHeaderList: any = {
    rfv: "REST-Framework-Version",
  };
  if (data.moreHead) {
    for (let item in data.moreHead) {
      headers[moreHeaderList[item]] = data.moreHead[item];
    }
  }

  // authentication
  if (data.auth == "token") {
    let authData = common.getAuth();
    headers.Authorization = "Bearer " + authData?.token; //.token;
  } else if (data.auth == "temp") {
    let tempData = common.tempDataGet();
    headers.Authorization = "Bearer " + tempData?.token;
  } else if (data.auth == "basic") {
    headers.Authorization =
      "Basic " + btoa(data.credentials.param1 + ":" + data.credentials.param2);
  } else {
    headers.Authorization = "Bearer " + data.auth;
  }
  return headers;
}

const validateData = (result: any) => {
  if (result.status == config.api.isExpired) {
    localStorage.clear();
    common.redirect();
    return false;
  } else {
    return true;
  }
};

const notify = (data: any, result: any) => {
  if (data.notify) {
    if (![200, 500, 400, 401].includes(result.status)) {
      // alert("Error through from api.ts")
    }
  }
};

// rToken
const refreshAccessToken = async () => {
  try {
    let authData = common.getAuth();
    const response = await fetch(config.api.url + "app/auth/token/refresh", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        refreshToken: authData?.refreshToken,
      }),
    });
    return response.text().then((data) => ({
      status: response.status,
      data: data,
    }));
  } catch (error) {
    console.log(error);
  }
};
